import React from 'react';
import { healthQuestionsConditions, healthQuestionsList } from 'const/questionsHealth';
import { isMobile } from 'react-device-detect';
import { Text, View } from '@coinscrap/webapp-core';
import InputLabel from 'components/InputLabel/InputLabel';
import { OptionButton } from 'components/OptionButton/OptionButton';

export const HealthQuestions = ({ healthQuestionsReponses, setHealthQuestionsReponses }) => {
	return healthQuestionsList.map((question, index) => (
		<View inputFreeRowSt key={question.id} style={index === 0 ? { marginTop: -20 } : undefined}>
			{healthQuestionsConditions(question, healthQuestionsReponses) && (
				<>
					{question.type === 'BOOLEAN' && (
						<View colSt>
							<InputLabel label={question.description} type="custom">
								<View
									rowSt
									justifyStartSt
									style={{
										gap: isMobile ? '20px' : '12px',
										flexWrap: 'wrap',
									}}
								>
									<OptionButton
										onClick={() =>
											setHealthQuestionsReponses((prevState) => {
												return {
													...prevState,
													[question.id]: true,
												};
											})
										}
										selected={healthQuestionsReponses[question.id] === true}
										text={'Sí'}
										style={{
											width: isMobile ? '100%' : undefined,
											margin: isMobile ? 0 : undefined,
										}}
									/>
									<OptionButton
										onClick={() =>
											setHealthQuestionsReponses((prevState) => {
												const newState = { ...prevState };
												healthQuestionsList.map((qs) => {
													if (qs.id === question.id) {
														newState[qs.id] = false;
													} else if (
														(qs?.dependencyQuestionNumber?.includes(
															question.id,
														) ||
															qs?.dependencyQuestionNumber?.includes(
																'ALL',
															)) &&
														qs.id > question.id
													) {
														newState[qs.id] = undefined;
													}
													return qs;
												});
												return newState;
											})
										}
										selected={healthQuestionsReponses[question.id] === false}
										text={'No'}
										style={{
											width: isMobile ? '100%' : undefined,
											margin: isMobile ? 0 : undefined,
										}}
									/>
								</View>
							</InputLabel>
							{question?.warning && (
								<Text marginTopMdSt mutedSt>
									{question?.warning}
								</Text>
							)}
						</View>
					)}

					{question.type === 'STRING' && (
						<View colSt>
							<InputLabel
								label={question.description}
								style={{
									width: '100%',
									maxWidth: 700,
									input: {
										minHeight: 75,
									},
								}}
								value={healthQuestionsReponses[question.id]}
								onChange={(e) => {
									const val = e.target.value;
									setHealthQuestionsReponses((prevState) => {
										return {
											...prevState,
											[question.id]: val,
										};
									});
								}}
							/>
							{question?.warning && (
								<Text marginTopMdSt mutedSt>
									{question?.warning}
								</Text>
							)}
						</View>
					)}

					{question.type === 'SELECT' && (
						<View colSt>
							<InputLabel
								style={{
									width: '100%',
									maxWidth: 350,
								}}
								label={question.description}
								value={healthQuestionsReponses[question.id] || 0}
								onChange={(e) => {
									const val = e.target.value;
									setHealthQuestionsReponses((prevState) => {
										return {
											...prevState,
											[question.id]: val,
										};
									});
								}}
								type="select"
								selectOptions={question.selectValues.map((item) => {
									return {
										label: item.label,
										value: item.label,
									};
								})}
							/>
							{question?.warning && (
								<Text marginTopMdSt mutedSt>
									{question?.warning}
								</Text>
							)}
						</View>
					)}
				</>
			)}
		</View>
	));
};
